module.exports = __webpack_public_path__ + "static/media/cert_104.e137bf90.jpg";